<template>
  <section v-if="value" class="rounded-md border border-gray-200 dark:border-gray-500 bg-white dark:bg-gray-700 p-4">
    <h3 class="mb-2 text-sm font-semibold text-gray-900 dark:text-gray-100">{{ label }}</h3>
    <div ref="viewerEl" />
  </section>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue';
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer';
import '@toast-ui/editor/dist/toastui-editor.css';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import '@toast-ui/editor/dist/theme/toastui-editor-dark.css';
import ThemeService from '@/services/ThemeService';

const props = defineProps({
  label: { type: String, required: true },
  value: { default: null },
});

const viewerEl = ref(null);
let viewer = null;

function fixMarkdownIndentation(text) {
  return String(text ?? '').split('\n').map(line => {
    if (line.startsWith(' - ')) line = '    - ' + line.slice(3);
    return line.replace(/^(#{1,6})([^\s#])/g, '$1 $2');
  }).join('\n');
}

function destroy() {
  if (viewer) {
    try { viewer.destroy(); } catch (_) { /* ignore */ }
    viewer = null;
  }
}

function mount() {
  destroy();
  if (!viewerEl.value || !props.value) return;
  viewerEl.value.innerHTML = '';
  viewer = new Viewer({
    el: viewerEl.value,
    initialValue: fixMarkdownIndentation(props.value),
    theme: ThemeService.isDark.value ? 'dark' : 'default',
  });
}

onMounted(() => nextTick(mount));
onBeforeUnmount(destroy);
watch(() => props.value, () => nextTick(mount));
watch(ThemeService.isDark, () => nextTick(mount));
</script>
